import { Component, Input, inject } from '@angular/core';
import { I18nService } from '@app/shared/utils/i18n.service';

export interface CategoryHeaderData {
	isEnabled: boolean;
	body: LocaleValue;
	header: LocaleValue;
	image?: LocaleValue;
}

@Component({
	selector: 'g-category-header',
	templateUrl: './category-header.component.html',
	styleUrls: ['./category-header.component.scss'],
	standalone: false,
})
export class CategoryHeaderComponent {
	private readonly i18n = inject(I18nService);

	@Input({ required: true }) readonly categoryHeaderData!: CategoryHeaderData;

	get isEnabled(): boolean {
		return this.categoryHeaderData?.isEnabled ?? false;
	}

	get body(): LocaleValue {
		return this.categoryHeaderData?.body;
	}

	get header(): LocaleValue {
		return this.categoryHeaderData?.header;
	}

	get image(): string {
		return this.i18n.getText(this.categoryHeaderData?.image);
	}

	hasTextContent(): boolean {
		return [this.header, this.body].some((context) => {
			return this.i18n.getText(context).length > 0;
		});
	}
}
